import type { RichContentEditorProps } from './../../ricos-common';
import { VERTICAL_EMBED_TYPE } from './../../ricos-content';

import { changeBaseUrl } from './changeBaseUrl';

export function verticalEmbedViewerStrategy(
  baseUrl: string,
  disabled = false
): RichContentEditorProps {
  return {
    config: {
      [VERTICAL_EMBED_TYPE]: {
        changeBaseUrl: (url: string) => changeBaseUrl(url, baseUrl),
        disabled,
      },
    },
  };
}
